import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Auth0Provider} from '@auth0/auth0-react';
import {createBrowserHistory} from 'history';
import {ThemeProvider} from "@mui/material";
import theme from "./theme";

const history = createBrowserHistory();

const onRedirectCallback = (appState: any) => {
    console.log("onRedirectCallback got used")
    history.push(
        appState && appState.returnTo ? appState.returnTo : window.location.pathname
    );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <Auth0Provider
                domain={"eichhoernchen.eu.auth0.com"}
                clientId={"55xwvzQ8gtOAJVWLBWvoJoBlseLd0bhZ"}
                onRedirectCallback={onRedirectCallback}
                authorizationParams={{
                    redirect_uri: window.location.origin,
                    audience: "pizza.eichhoernchen.cloud",
                }}>
                <App/>
            </Auth0Provider>
        </ThemeProvider>
    </React.StrictMode>
)
;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(null);
